import { CircularProgress } from '@mui/material';
import { getMeetingListFromAuthUserIdApi, getUserPartcMeetingListFromAuthUserIdApi } from 'api/meeting';
import WatchingMeetingDataTable from 'app/components/DataTable/watching/WatchingMeetingDataTable';
import LoadingPopUp from 'app/components/LoadingPopup';

import React, { useEffect, useState } from 'react';

const WatchingMeetingPage = () => {

    const [loading, setLoading] = useState(false);
    const [meetingList, setMeetingList] = useState([]);


    useEffect(() => {
        const getAPI = async () => {

            setLoading(true)
            let res = await getMeetingListFromAuthUserIdApi("management"); // yetkili olduğu meetingler
            let res2 = await getUserPartcMeetingListFromAuthUserIdApi(); // üye veya katılımcı olduğu meetingler

            let data = res.data;
            // res = data.filter(meeting => meeting.statFinish === 1 || meeting.statVote === 1 || meeting.statReview === 1 || meeting.statVideo === 1);
            // res = res.data;
            res2 = res2.data;

            const existingIds = new Set(data.map(meeting => meeting.id));
            const uniqueRes2 = res2.filter(meeting => !existingIds.has(meeting.id));
            setMeetingList([...data, ...uniqueRes2]);

            setLoading(false);
        }

        getAPI()
    }, [])


    const columnData = [
        { id: 'inst', align: 'center', disablePadding: false, label: "Kurum" },
        { id: 'unit', align: 'left', disablePadding: false, label: "Kurul/Kol/Komisyon" },
        { id: 'meetingNo', align: 'left', disablePadding: false, label: "Toplantı No" },
        { id: 'pdate', align: 'left', disablePadding: false, label: "Tarih" },
        { id: 'adminUserId', align: 'left', disablePadding: true, label: "Toplantı Yöneticisi" },
        { id: 'statFinish', align: 'left', disablePadding: true, label: "Durum" },
        { id: 'watch', align: 'center', disablePadding: true, label: "Toplantı İzle" },

    ];


    return (
        <React.Fragment>


            <>
                <LoadingPopUp open={loading} />
                {!loading && <WatchingMeetingDataTable mainData={meetingList} column={columnData} pageTitle="Toplantı Listesi" />}
            </>


        </React.Fragment>
    );
};

export default WatchingMeetingPage;